import React from 'react';
import styled from 'styled-components';
import { Row } from 'react-bootstrap';

const Privacy = () => {
  return (
    <Container>
      <Row>
        <h1
          style={{
            fontSize: '32px',
            fontWeight: 'bold',
            textAlign: 'center',
            width: '100%',
            paddingTop: '10%',
            color: '#C00018',
          }}
        >
          <strong>Balwin Properties Limited</strong>
        </h1>
        <p
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
            width: '100%',
            paddingTop: '2%',
            color: '#C00018',
          }}
        >
          Privacy Policy
        </p>
        <p
          style={{
            fontWeight: 'bold',
            textAlign: 'center',
            width: '100%',
            paddingTop: '2%',
            color: '#C00018',
            marginBottom: '4%',
            marginTop: 0,
          }}
        >
          Version 1.5 (updated 7 February 2024)
        </p>
        <p style={{ width: '100%' }}>
          <strong>1. Our Commitment</strong>
        </p>
        <p style={{ width: '100%' }}>
          Balwin Properties Limited is committed to the lawful and responsible
          collection and processing of your personal information. This privacy
          policy outlines Balwin Properties Limited&rsquo;s practices in this
          regard.
        </p>
        <p style={{ width: '100%' }}>
          <strong>2. Personal Information</strong>
        </p>
        <p style={{ width: '100%' }}>
          2.1. Personal information includes any information which identifies
          you as a unique individual. We will request certain fundamental
          personal information when you register as a user of the App and
          thereafter, you may be requested to furnish additional personal
          information necessary for certain specific functionalities and/or
          services offered in the App. The requested personal information may
          include your:&nbsp;
        </p>
        <p style={{ width: '100%' }}>2.1.1. name and surname</p>
        <p style={{ width: '100%' }}>2.1.2. identity number</p>
        <p style={{ width: '100%' }}>2.1.3. date of birth</p>
        <p style={{ width: '100%' }}>2.1.4. gender</p>
        <p style={{ width: '100%' }}>2.1.5. mobile number</p>
        <p style={{ width: '100%' }}>2.1.6. email address</p>
        <p style={{ width: '100%' }}>2.1.7. physical address</p>
        <p style={{ width: '100%' }}>2.1.8. vehicle registration number</p>
        <p style={{ width: '100%' }}>
          2.1.9. municipal rates and taxes account number
        </p>
        <p style={{ width: '100%' }}>2.1.10. location</p>
        <p style={{ width: '100%' }}>2.1.11. telephone contact list</p>
        <p style={{ width: '100%' }}>2.1.12. images or photos</p>
        <p style={{ width: '100%' }}>
          collectively hereinafter referred to as (&ldquo;personal
          information&rdquo;)
        </p>
        <p style={{ width: '100%' }}>
          2.2. If you choose to provide us with your personal information, you
          agree to provide accurate and current information and not to
          misrepresent yourself in any way. Please inform us as soon as
          reasonably possible of any changes to your personal information so
          that we may make the appropriate updates to our records.
        </p>
        <p style={{ width: '100%' }}>
          2.3. The general purposes for which Balwin Properties Limited collects
          and processes your personal information and location data includes,
          but are not limited to the following:
        </p>
        <p style={{ width: '100%' }}>
          2.3.1. the delivery of products, services and/or functionality offered
          through the App with specific reference to access control in the
          relevant estate and/or building that you reside, work and/or visit,
          which includes but is not limited to, fault logging, account balances
          and payments, bookings, events, insurance, notifications, emergency
          contacts and access control;
        </p>
        <p style={{ width: '100%' }}>
          2.3.2. to contact you for the delivery of relevant information or
          notices pertaining to the relevant estate and/or building that you
          reside, work and/or visit;
        </p>
        <p style={{ width: '100%' }}>
          2.3.3. to inform you of current or new products or services, features,
          special offers and promotional competitions offered by us or any of
          our partners and/or product or service providers (unless you have
          opted out of receiving marketing material from us); and
        </p>
        <p style={{ width: '100%' }}>
          2.3.4. to improve our product and service selection and your
          experience of our App service by, amongst other things, monitoring
          your in-App activity and/or tracking your purchases on the App.
        </p>
        <p style={{ width: '100%' }}>
          <strong>3. Location Data</strong>
        </p>
        <p style={{ width: '100%' }}>
          3.1. The App makes use of your location and, in order that the app may
          function effectively, it requires the user&rsquo;s location. Whenever
          the App is opened on a device, it uses the location information from
          the user&rsquo;s device to tailor the App experience to the
          user&rsquo;s current location. This information will not be shared
          with third-parties without the user&rsquo;s express consent.&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          3.2. The App makes use of the user&rsquo;s device &ldquo;background
          location&rdquo; to enable access control functionality. If
          &ldquo;background location&rdquo; is approved, the App will, from time
          to time, tell Balwin Properties Limited about the device location of
          the user even if the user is not directly interacting with the
          application (i.e., the App is closed or not in use).&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          3.3. If &ldquo;background data&rdquo; is declined in the user&rsquo;s
          device settings, the access control functionality of the App will be
          reduced and/or negatively affected.
        </p>
        <p style={{ width: '100%' }}>
          3.4. When the user makes use of the App, Balwin Properties Limited may
          collect and process information about the user&rsquo;s actual
          location. Balwin Properties Limited uses various technologies to
          determine location including but not limited to IP address, GPS and
          other sensors that may, for example, provide Balwin Properties Limited
          with information on nearby devices such as WI-FI access points and
          cell towers.
        </p>
        <p style={{ width: '100%' }}>
          <strong>4. Your Rights</strong>
        </p>
        <p style={{ width: '100%' }}>
          4.1. You have the following, non-exhaustive, rights regarding your
          personal information:
        </p>
        <p style={{ width: '100%' }}>
          4.1.1. the right to access your personal information that we have on
          record;
        </p>
        <p style={{ width: '100%' }}>
          4.1.2. the right to ask Balwin Properties Limited to correct any of
          your personal information that is incorrect;
        </p>
        <p style={{ width: '100%' }}>
          4.1.3. the right to ask Balwin Properties Limited to delete or destroy
          your personal information;&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          4.1.4. the right to object to Balwin Properties Limited processing
          your personal information.&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          4.2. To exercise any of your rights mentioned above or if you have a
          complaint relating to the protection of your personal information,
          including the way in which it has been collected or processed, please
          contact us at support@thinkdigital.co.za
        </p>
        <p style={{ width: '100%' }}>
          <strong>5. App Functionality</strong>
        </p>
        <p style={{ width: '100%' }}>
          5.1. The App requires accurate and complete records of certain
          personal information to function optimally. If you:
        </p>
        <p style={{ width: '100%' }}>
          5.1.1. provide us with incorrect or incomplete personal information;
          or
        </p>
        <p style={{ width: '100%' }}>
          5.1.2. withdraw your consent for us to process your personal
          information; or&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          5.1.3. request that we delete or destroy your personal information;
        </p>
        <p style={{ width: '100%' }}>
          the functionality and reliability of the App and the products/services
          offered in the App will be reduced and/or negatively affected.
        </p>
        <p style={{ width: '100%' }}>
          <strong>6. Disclosure of Personal Information</strong>&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          6.1. Balwin Properties Limited will not, without your express consent,
          disclose your personal information to any third-party, other
          than:&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          6.1.1. to our employees or contractors;&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          6.1.2. when we are legally obliged to do so, to: law enforcement;
          government officials; fraud detection agencies; or other third-parties
          when we believe in good faith that the disclosure of personal
          information is necessary to prevent physical harm or financial loss;
        </p>
        <p style={{ width: '100%' }}>
          6.1.3. to our partners who supply goods and services though the App or
          who are engaged with our business operations; and
        </p>
        <p style={{ width: '100%' }}>
          6.1.4. to third-party goods and service providers in order for them to
          liaise directly with you in the event of you submitting a complaint or
          claim regarding any order you have placed which requires their direct
          involvement.
        </p>
        <p style={{ width: '100%' }}>
          6.2. We will ensure that all our employees, contractors and partners
          (including their employees and third-party service providers) having
          access to your personal information are bound by appropriate and
          legally binding confidentiality obligations in relation to such
          information.
        </p>
        <p style={{ width: '100%' }}>
          <strong>7. General</strong>
        </p>
        <p style={{ width: '100%' }}>We will -</p>
        <p style={{ width: '100%' }}>
          7.1. treat your personal information as strictly confidential, save
          where we are entitled to share it as set out in this Privacy
          Policy;&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          7.2. take appropriate technical and organisational measures to ensure
          that your personal information is kept secure and is protected against
          unauthorised or unlawful processing, accidental loss, destruction or
          damage, alteration, disclosure or access;
        </p>
        <p style={{ width: '100%' }}>
          7.3. provide you with access to your personal information to view
          and/or update personal details;
        </p>
        <p style={{ width: '100%' }}>
          7.4. promptly notify you if we become aware of any unauthorised use,
          disclosure or processing of your personal information;&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          7.5. provide you with reasonable evidence of our compliance with our
          obligations under this Privacy Policy on reasonable notice and
          request;
        </p>
        <p style={{ width: '100%' }}>
          7.6. upon your request, promptly return or destroy any and all of your
          personal information in our possession or control, save for that which
          we are legally obliged to retain;
        </p>
        <p style={{ width: '100%' }}>
          7.7. not retain your personal information longer than the period for
          which it was originally needed, unless we are required by law to do so
          or you consent to us retaining such information for a longer period;
        </p>
        <p style={{ width: '100%' }}>
          7.8. do all things reasonably necessary to protect your rights of
          privacy.
        </p>
        <p style={{ width: '100%' }}>
          <strong>8. Limitation of Liability</strong>
        </p>
        <p style={{ width: '100%' }}>
          BALWIN PROPERTIES LIMITED SHALL NOT BE LIABLE FOR ANY LOSS OR DAMAGE,
          HOWSOEVER ARISING, SUFFERED BY YOU AS A RESULT OF:
        </p>
        <p style={{ width: '100%' }}>
          8.1. the unauthorised or unlawful disclosure of your personal
          information, whilst in our possession, made by third-parties who are
          not subject to our control, unless such disclosure is as a result of
          our gross negligence; and
        </p>
        <p style={{ width: '100%' }}>
          8.2. your disclosure of your personal information to a third-party,
          such as an entity partnered with Balwin Properties Limited or an
          entity which operates a website linked to the App, or anyone other
          than Balwin Properties Limited.&nbsp;
        </p>
        <p style={{ width: '100%' }}>
          <strong>9. Age of consent</strong>
        </p>
        <p style={{ width: '100%' }}>
          By using this site and the App, you represent that you are at least
          the age of 18 years old, or, in the event that you are less than 18
          years old, that you are being assisted by a legally competent person.
        </p>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  width: 95% !important;
  height: 100%;
  position: relative;
  float: none;
  margin: 0 auto;
  background: #fff;
  padding: 2%;
`;

export default Privacy;
